// extracted by mini-css-extract-plugin
export var carouselLayout__mobileSlides = "carousel-layout-module--carousel-layout__mobileSlides--18c07";
export var carouselLayout__slides = "carousel-layout-module--carousel-layout__slides--5a8c3";
export var carouselLayout__slides__container = "carousel-layout-module--carousel-layout__slides__container--47e6b";
export var mt0 = "carousel-layout-module--mt-0--15dcb";
export var mt1 = "carousel-layout-module--mt-1--09428";
export var mt2 = "carousel-layout-module--mt-2--d2726";
export var mt3 = "carousel-layout-module--mt-3--ef6fa";
export var mt4 = "carousel-layout-module--mt-4--a81e0";
export var mt5 = "carousel-layout-module--mt-5--90119";
export var mt6 = "carousel-layout-module--mt-6--24882";